import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// eslint-disable-next-line no-unused-vars
import i18next from './lang/i18next'; // non togliere questa riga!
import { BusyProvider } from './context/BusyContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BusyProvider>
      <App />
    </BusyProvider>
  </React.StrictMode>
);